import TitlePage from "@components/atoms/TitlePage/TitlePage";
import DynamicTable from "../DynamicTable/DynamicTable";
import { IRemisionDispatchMovementsUI } from "src/types/organisms";
const RemisionDispatchMovementsUI = ({
  title,
  subtitle,
  headers,
  rows,
  pages,
  isLoading,
  onChangePage,
  emptyMessage
}: IRemisionDispatchMovementsUI) => {
  return <>
      <TitlePage title="Historial de despachos" subtitle={subtitle} />
      <DynamicTable title={title} headers={headers} rows={rows} pages={pages} isLoading={isLoading} onChangePage={onChangePage} emptyMessage={emptyMessage} />
    </>;
};
export default RemisionDispatchMovementsUI;